// extracted by mini-css-extract-plugin
export default {"inputGroup":"address_record_inputGroup__ENBv5","formLabelMobile":"address_record_formLabelMobile__TJVv9","td":"address_record_td__6x+uU","tdFake":"address_record_tdFake__BvtZr"};